// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__eqmP0","col":"Table_col__3e9uK","fulfillmentStatus":"Table_fulfillmentStatus__3G8pz","emailCol":"Table_emailCol__1pk7q"};